// extracted by mini-css-extract-plugin
module.exports = {"bannerButtons":"BannerButtons_bannerButtons__C4cdg"};